module.exports = __webpack_public_path__ + "static/media/r171070.a5166efe.pdf";